module.exports = __webpack_public_path__ + "6c3c81192fcda539343956588604354f.svg";